import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { GridFetchModel } from './../../models/grid/grid-fetch.model';
import {
  AuthenticationService, UtilityService, ValidationService,
  LicensePricingService, AdobeAnalyticsService
} from 'lib/ng2-sapmp/src/providers';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { ChangeProductService } from './shared';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { DROPDOWN, BREADCRUMBS } from 'config';
import { ReviewOrderProductModel, ProductDetailsModel } from '../manage-product/review-order-product';
import {
  ProductModel, PriceModel, RequestLineItemModel, LineItemModel, SkusModel, PriceInfoModel,
  TotalPriceInfoModel
} from './../../models';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;

@Component({
  selector: 'app-change-product',
  templateUrl: './change-product.component.html',
  providers: [ValidationService, ChangeProductService, LicensePricingService],
  styleUrls: ['./change-product.component.scss']

})
export class ChangeProductComponent implements OnInit, OnDestroy, AfterViewInit {

  changeProductForm: FormGroup;

  // productDetail: ProductModel;
  productDetail: any = {};
  tmpPricingObj: any = [];
  totPricingObj: any = [];
  breadCrumbs: BreadCrumbModel[];
  selectedindex = 0;
  previousQtyAmt: number;
  reviewOrder: ReviewOrderProductModel;
  initialQty: any = 1;
  proceedToReview = false;
  disableContinueToReview = false;
  tmpQty: any = 1;
  requestPriceInfoObj = {
    id: '',
    quantity: 0
  };
  dataObj = {
    dcmCodes: [],
    quantity: 0
  };
  OwnedProductData = {
    credentialType: 'MOBILEIDENTIFIER',
    credentialId: '',
    dcmCode: ''
  };
  setError: boolean;
  ErrorMessage: string;
  getOwnProdDetails: any;
  currentProd: any;
  volumeContent: any = {};
  usersProductData: any = null;
  selectedBundleSkuId: string;
  noAdditionalOptions = false;
  pivots: Array<MobilePivotModel>;
  selectedSkuType = '';
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private utilityService: UtilityService,
    private licensePricingService: LicensePricingService,
    private http: HttpClient, private pageloaderService: PageLoaderService,
    private changeProductService: ChangeProductService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private breadCrumbService: BreadCrumbService) {
    this.pivots = new Array<MobilePivotModel>();
  }

  ngOnInit() {
    if (sessionStorage.getItem('singleUserDetail') === null) {
      this.router.navigate(['/home']);
    } else {
      // document.title = 'AT&T Business Console - Change package';
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      document.body.classList.add('changeproduct-page');
      this.pageloaderService.setPageLoaderStatus(false);
      this.usersProductData = JSON.parse(sessionStorage.getItem('singleUserDetail'));
      this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
      this.breadCrumbService.setCurrentBreadCrumb({ 'label': 'Change package', 'routerLink': this.router.routerState.snapshot.url });
      this.pivots.push({ label: 'Manage Products', routerLink: '/manage' });
      this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
      this.reviewOrder = JSON.parse(sessionStorage.getItem('reviewModel'));
      if (this.reviewOrder !== null && !!this.reviewOrder.newProduct && this.reviewOrder.newProduct !== null) {
        this.selectedSkuType = this.reviewOrder.newProduct;
      }
      this.getOwnedProductInfo();
      this.buildForm();
    }
  }
  /**
   * Below response is in array format,so we are getting the first index element of data.
   */
  private priceUpdate() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.requestPriceInfoObj.id = this.usersProductData.serviceOfferCode;
    this.requestPriceInfoObj.quantity = this.usersProductData.quantity;
    this.changeProductService.getApplicableProductDetails(this.utilityService.getEnvConfig().changeProductUrl, this.requestPriceInfoObj
    ).subscribe(respobj => {
      this.pageloaderService.setPageLoaderStatus(true);
      const pricingrespobj = respobj[0];
      this.setError = false;
      this.ErrorMessage = '';
      if (pricingrespobj.skus && pricingrespobj.skus.length > 1) {
        this.processProductInfo(pricingrespobj);
        if (this.selectedSkuType) {
          const selectProduct = pricingrespobj.skus.find(data => (data.skuType === this.selectedSkuType));
          this.totalCalculation(selectProduct.id);
        }
        this.checkProudctIsPurchasedDiffCtn();
      } else {
        this.noAdditionalOptions = true;
      }
    }, error => {
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
      this.setErrorMessage(error, true);
    });
  }

  private getOwnedProductInfo() {
    this.OwnedProductData.credentialId = this.usersProductData.billingClientId;
    this.OwnedProductData.dcmCode = this.usersProductData.serviceOfferCode;
    this.licensePricingService.getPricingForOwenedQty(this.OwnedProductData)
      .subscribe(respobj => {
        this.getOwnProdDetails = respobj;
        this.pageloaderService.setPageLoaderStatus(true);
        this.setError = false;
        this.ErrorMessage = '';
        this.priceUpdate();
      }, error => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.setErrorMessage(error, true);
      });
  }

  processProductInfo(pricingrespobj) {
    this.tmpPricingObj = pricingrespobj;
    this.productDetail = pricingrespobj;
    this.tmpPricingObj.skus.forEach((skuobj, sIndex) => {
      const tempPriceInfoObject = {
        'totalOneTimeFee': 0, 'monthlyRecurringFee': {}, 'dcmCode': '', 'oneTimeFee': [],
        'totalOneTimeFeeWithDiscount': 0, 'totalOneTimeFeeEstimatedDiscount': 0
      };
      skuobj.bundleSkus.forEach((bskus, oIndex) => {
        if (bskus.priceDetails) {
          if (bskus.priceDetails.priceType === 'oneTimeFee') {
            tempPriceInfoObject.totalOneTimeFee += bskus.priceDetails.totalPrice;
            tempPriceInfoObject.totalOneTimeFeeWithDiscount += bskus.priceDetails.totalPriceWithDiscount;
            tempPriceInfoObject.totalOneTimeFeeEstimatedDiscount += (bskus.priceDetails.applicableDiscount)
              ? bskus.priceDetails.applicableDiscount : 0;
            if (bskus.priceDetails.totalPrice) {
              bskus.priceDetails['oneTimeFeeName'] = bskus.displayName;
              tempPriceInfoObject.oneTimeFee.push(bskus.priceDetails);
            }
          } else if (bskus.priceDetails.priceType === 'monthlyRecurringFee') {
            tempPriceInfoObject.monthlyRecurringFee = bskus.priceDetails;
            tempPriceInfoObject.dcmCode = bskus.dcmCode;
          }
        }
      });
      this.productDetail.skus.forEach((prodobj, pIndex) => {
        if (skuobj.id === prodobj.id) {
          this.productDetail.skus[pIndex].isHidden = false;
          this.productDetail.skus[pIndex].priceInfo = tempPriceInfoObject;
        }
      });
      if (skuobj.skuType === this.selectedSkuType) {
        skuobj.selected = true;
        this.proceedToReview = true;
      }
    });
    this.productDetail.skus.sort((sku1, sku2): number => {
      return (parseInt(sku1.basicPrice, 10) - parseInt(sku2.basicPrice, 10));
    });
    this.productDetail.skus.sort((sku1, sku2): number => {
      return (sku2.selected - sku1.selected);
    });
  }

  private totalCalculation(skudId) {
    this.totPricingObj = {};
    this.totPricingObj.selectedItem = this.productDetail.skus.find(data => (data.id === skudId));
    this.totPricingObj.oneTime = this.totPricingObj.selectedItem.priceInfo['oneTimeFee'];
    this.totPricingObj.totalOneTime = this.totPricingObj.selectedItem.priceInfo['totalOneTimeFee'];
    this.totPricingObj.totalOneTimeFeeWithDiscount = this.totPricingObj.selectedItem.priceInfo['totalOneTimeFeeWithDiscount'];
    this.totPricingObj.totalOneTimeFeeEstimatedDiscount = this.totPricingObj.selectedItem.priceInfo['totalOneTimeFeeEstimatedDiscount'];
    this.totPricingObj.perMonth = this.totPricingObj.selectedItem.priceInfo['monthlyRecurringFee'];
    this.totPricingObj.dcmCode = this.totPricingObj.selectedItem.priceInfo['dcmCode'];
    this.totPricingObj.selectedItem.bundleSkus.forEach((bskus) => {
      if (bskus.priceDetails && bskus.priceDetails.priceType === 'monthlyRecurringFee') {
        this.selectedBundleSkuId = bskus.dcmCode;
      }
    });
  }

  radioSelection(rowIndex, skuId, event) {
    event.preventDefault();
    this.productDetail.skus.forEach((productObj) => {
      productObj.selected = (productObj.id === skuId) ? 1 : 0;
    });
    this.selectedindex = rowIndex;
    this.totalCalculation(skuId);
    if (!this.disableContinueToReview) {
      this.proceedToReview = true;
      this.setError = false;
      this.ErrorMessage = '';
    }
  }

  /**
     * Call to check whether the current variant of product is purchased under different CTN. In this case we have to
     * stop user from changing product variant as there cannot be multiple variant of same product purchased under one
     * company ID.
     */
  private checkProudctIsPurchasedDiffCtn() {
    this.pageloaderService.setPageLoaderStatus(false);
    let isValid = false;
    const gridfetchModel: GridFetchModel = new GridFetchModel();
    const fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();
    gridfetchModel.serviceStatus = 'ACTIVE';
    gridfetchModel.serviceOfferCodes = [this.getOwnProdDetails.vendorProductId];
    const companyId = JSON.parse(sessionStorage.getItem('user')).user.companyId;
    const ValidateChangeProduct = (this.utilityService.getEnvConfig().ValidateChangeProduct).replace('{companyid}', companyId)
      + this.usersProductData.billingClientId;
    this.changeProductService.getEligibleProductForCtnDetails(ValidateChangeProduct, gridfetchModel)
      .subscribe(response => {
        this.setError = false;
        this.ErrorMessage = '';
        isValid = response;
        if (isValid) {
          this.proceedToReview = true;
        } else {
          this.proceedToReview = false;
          this.setError = true;
          if (ENV_PORTAL === 'sapmp') {
            this.ErrorMessage = 'To change products for more than 1 wireless number, call 866.241.6588 (TTY/TDD 866.241.6567), M - F,'
              + ' 7am-9pm ET. Or chat with an expert by selecting Chat available M - F, 8 a.m.-8 p.m., and Sa - Su 8 a.m.-5 p.m. ET.';
          } else {
            this.ErrorMessage = 'To change products for more than 1 wireless number, call 800.574.7000, M - F,'
              + '8 am-10pm ET. Or chat with an expert by selecting Chat available M - F, 8am-8pm, and Sa - Su, 8am-5pm ET.';
          }
          this.productDetail.skus.forEach((prodobj, pIndex) => {
            this.productDetail.skus[pIndex].isHidden = true;
          });
          this.utilityService.loadFocusOnTop();
        }
        this.pageloaderService.setPageLoaderStatus(true);
      }, error => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.setErrorMessage(error, false);
      });
  }

  confirmSelectedProduct(event) {
    this.pageloaderService.setPageLoaderStatus(false);
    let isValid = false;
    const gridfetchModel: GridFetchModel = new GridFetchModel();
    const fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();
    gridfetchModel.serviceStatus = 'ACTIVE';
    gridfetchModel.serviceOfferCodes = [this.getOwnProdDetails.vendorProductId];
    const companyId = JSON.parse(sessionStorage.getItem('user')).user.companyId;
    const ValidateChangeProduct = (this.utilityService.getEnvConfig().ValidateChangeProduct).replace('{companyid}', companyId)
      + this.usersProductData.billingClientId;
    /**
     * Call to check whether the current variant of product is purchased under different CTN. In this case we have to
     * stop user from changing product variant as there cannot be multiple variant of same product purchased under one
     * company ID.
     */
    this.changeProductService.getEligibleProductForCtnDetails(ValidateChangeProduct, gridfetchModel)
      .subscribe(response => {
        this.setError = false;
        this.ErrorMessage = '';
        isValid = response;
        if (isValid) {
          this.proceedToReview = true;
          this.goToReviewOrder(event);
        } else {
          this.proceedToReview = false;
          this.setError = true;
          if (ENV_PORTAL === 'sapmp') {
            this.ErrorMessage = 'To change products for more than 1 wireless number, call 866.241.6588 (TTY/TDD 866.241.6567), M - F,'
              + ' 7am-9pm ET. Or chat with an expert by selecting Chat available M - F, 8 a.m.-8 p.m., and Sa - Su 8 a.m.-5 p.m. ET.';
          } else {
            this.ErrorMessage = 'To change products for more than 1 wireless number, call 800.574.7000, M - F,'
              + '8 am-10pm ET. Or chat with an expert by selecting Chat available M - F, 8am-8pm, and Sa - Su, 8am-5pm ET.';
          }
          this.productDetail.skus.forEach((prodobj, pIndex) => {
            if (this.totPricingObj.dcmCode === prodobj.id) {
              this.productDetail.skus[pIndex].isHidden = true;
            }
          });

          this.utilityService.loadFocusOnTop();
          this.pageloaderService.setPageLoaderStatus(true);
        }
      }, error => {
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.setErrorMessage(error, false);
      });
  }

  goToReviewOrder(event) {
    // setting data for review order page
    try {
      this.pageloaderService.setPageLoaderStatus(false);
      this.reviewOrder = new ReviewOrderProductModel();
      this.reviewOrder.fan = this.usersProductData.brokerAccountClientId;
      this.reviewOrder.ctn = this.utilityService.formatTelephoneNumber(this.usersProductData.billingClientId);
      this.reviewOrder.description = this.usersProductData.productDesc ? this.usersProductData.productDesc : '';
      this.reviewOrder.unitPrice = (this.totPricingObj.perMonth.customPrice)
        ? this.totPricingObj.perMonth.customPrice : this.totPricingObj.perMonth.unitPrice;
      this.reviewOrder.totalLicense = this.usersProductData.quantity;
      this.reviewOrder.type = 'changeProduct';
      this.reviewOrder.currentProduct = this.usersProductData.specName;
      this.reviewOrder.newProduct = this.totPricingObj.selectedItem.skuType;
      this.reviewOrder.product = this.tmpPricingObj.displayName + ' - ' + this.totPricingObj.selectedItem.skuType;
      this.reviewOrder.backUrl = 'changeProduct';
      this.reviewOrder.lineItems = this.generateLineItems();
      this.reviewOrder.subscriptionId = this.getOwnProdDetails.purchaseIdentifier;
      this.reviewOrder.unitTotalAmount = this.totPricingObj.perMonth.totalPrice;
      this.reviewOrder.estimatedDiscount = (this.totPricingObj.perMonth.applicableDiscount)
        ? this.totPricingObj.perMonth.applicableDiscount : 0;
      this.reviewOrder.totalAmount = (this.totPricingObj.perMonth.totalPriceWithDiscount) ?
        this.totPricingObj.perMonth.totalPriceWithDiscount : this.totPricingObj.perMonth.totalPrice;
      this.reviewOrder.oneTimeFeeInfo = this.totPricingObj.oneTime;
      this.reviewOrder.oneTimeFee = (this.totPricingObj.totalOneTimeFeeWithDiscount) ?
        this.totPricingObj.totalOneTimeFeeWithDiscount : this.totPricingObj.totalOneTime;
      this.reviewOrder.oneTimeFeeEstimatedDiscount = this.totPricingObj.totalOneTimeFeeEstimatedDiscount;
      sessionStorage.setItem('reviewModel', JSON.stringify(this.reviewOrder));
      this.pageloaderService.setPageLoaderStatus(true);
      this.router.navigate(['manageProduct/revieworderproduct']);
    } catch (e) {
      this.setErrorMessage('error', true);
    }
  }

  generateLineItems() {
    const lineItems = Array<ProductDetailsModel>();

    const existingItem: ProductDetailsModel = new ProductDetailsModel();
    existingItem.productId = this.productDetail.id;
    existingItem.dcmCode = this.getOwnProdDetails.vendorProductId;
    existingItem.socCode = this.getOwnProdDetails.billingCode;
    existingItem.quantity = this.usersProductData.quantity;
    existingItem.bundleSkuId = this.getOwnProdDetails.vendorProductId;
    existingItem.action = 'REMOVE';


    const newItem: ProductDetailsModel = new ProductDetailsModel();
    newItem.productId = this.productDetail.id;
    newItem.dcmCode = this.totPricingObj.dcmCode;
    newItem.socCode = this.totPricingObj.selectedItem.socCode;
    newItem.quantity = this.usersProductData.quantity;
    newItem.bundleSkuId = this.selectedBundleSkuId;
    newItem.action = 'ADD';
    newItem.childDcmCodes = [];
    for (const childSku of this.productDetail.skus) {
      if (childSku.id !== newItem.bundleSkuId) {
        newItem.childDcmCodes.push(childSku.id);
      }
    }
    lineItems.push(existingItem);
    lineItems.push(newItem);

    return lineItems;
  }

  setErrorMessage(err, isPageInitErr) {
    this.pageloaderService.setPageLoaderStatus(true);
    if (err.status === 500) {
      this.setError = true;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
    } else if (err.status === 400) {
      this.setError = true;
      
      if (err.error[0]) {
         this.ErrorMessage = JSON.stringify(err.error[0]);
      } else if (err.error) {
         this.ErrorMessage = err.error;
      }
      else {
        this.ErrorMessage = 'Can not add more than max-qty';
      }
    } else if (err.status === 401) {
      this.setError = true;
      this.ErrorMessage = 'Session expired, Please login again.';
      logoutCurrentUser(true);
    } else {
      this.setError = true;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
    }
    this.utilityService.loadFocusOnTop();
    // disabling continue button, on load error scenarios
    if (isPageInitErr) {
      this.disableContinueToReview = true;
    }
    this.proceedToReview = false;
    this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, this.ErrorMessage, 'formResponse');
  }

  buildForm(): void { // creating formcontrol as a group that is used as formControlName in html
    this.changeProductForm = this.formBuilder.group({
      qty: [[]]
    });
  }

  ngAfterViewInit() {
    this.changeProductService.createPageLoadProperties(this.usersProductData.serviceOfferCode,
      this.router.routerState.snapshot.url, 'Change Product');
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
